import dayjs from 'dayjs'
import {
  BillInfo,
  Cheque,
  ChequeState,
  ChequeType,
  IFetchChequeResponsePayload,
  PaginationType
} from './cheque.types'

export const DEFAULT_PAGE_SIZE = 1000

export const formatChequesData = (
  data: IFetchChequeResponsePayload
): { cheques: Cheque[]; pagination: PaginationType } => {
  const {
    pagination_details: { per_page, page, total_items },
    cheque_details
  } = data

  const cheques = cheque_details.reduce((result: Cheque[], cheque) => {
    cheque.bills.forEach((bill: BillInfo) => {
      result.push({
        customerName: cheque.account_info.name,
        invoiceNumber: bill.bill_number,
        invoiceDate: bill.bill_date,
        chequeUrl: cheque.cheque_url || '',
        collectedOn: cheque.collected_on,
        chequeDate: cheque.cheque_date,
        chequeNo: cheque.cheque_number,
        amount: Number(cheque.amount || 0) / 100,
        chequeId: cheque.cheque_id,
        chequeState: cheque.state
      })
    })
    return result
  }, [])
  return {
    cheques,
    pagination: {
      pageSize: Number(per_page),
      currentPage: Number(page),
      totalEntries: Number(total_items)
    }
  }
}

export const CheuqueStateToStoreMapper: Record<any, ChequeType> = {
  [ChequeState.RECEIVED]: 'receivedCheque',
  [ChequeState.DEPOSITED]: 'depositedCheque',
  [ChequeState.CLEARED]: 'clearedCheque'
}

const chequeReceivedKeyMapper: { [key in keyof Cheque]?: string } = {
  customerName: 'Customer Name',
  invoiceNumber: 'Invoice Number',
  invoiceDate: 'Invoice Date',
  collectedOn: 'Collected On',
  chequeDate: 'Cheque Date',
  chequeNo: 'Cheque Number',
  amount: 'Amount'
}

export const formatChequeReceivedDataForExcel = (data: Cheque[]) => {
  return data.map((obj) => {
    return (Object.keys(obj) as (keyof Cheque)[]).reduce((acc: { [key: string]: any }, key) => {
      if (obj[key] !== undefined && key !== 'chequeId') {
        // Ensure the value exists
        const newKey = chequeReceivedKeyMapper[key] || key // Use mapped key or keep the original
        if (key === 'chequeDate' || key === 'invoiceDate' || key === 'collectedOn') {
          acc[newKey] = dayjs(Number(obj[key] || 0) * 1000).format('DD MMM YYYY')
        } else {
          acc[newKey] = obj[key]
        }
      }
      return acc
    }, {})
  })
}
